import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import { CurrencyProvider } from "@/lib/currency";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Vetrina from "@/pages/Vetrina";
import Dashboard from "@/pages/Dashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentStatus";
import Trade from "@/pages/Trade";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Pricing from "@/pages/Pricing";
import GuestPortal from "@/pages/GuestPortal";
import GuestAuth from "@/pages/GuestAuth";
import GuestAuthCallback from "@/pages/GuestAuthCallback";
import GuestMagicConsume from "@/pages/GuestMagicConsume";
import GuestDashboard from "@/pages/GuestDashboard";
import GuestWelcome from "@/pages/GuestWelcome";
import GuestBookingDetail from "@/pages/GuestBookingDetail";
import Directory from "@/pages/Directory";
import SelfCheckin from "@/pages/SelfCheckin";
import Welcome from "@/pages/Welcome";
import TreasureHunt from "@/pages/TreasureHunt";
import WallOfBadges from "@/pages/WallOfBadges";
import CityPage from "@/pages/CityPage";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator && window.location.protocol === "https:") {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    }
  }, []);
  return (
    <LanguageProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <PushNavigationBridge/>
          <Routes>
            <Route path="/" element={<Landing/>} />
            <Route path="/strutture" element={<Directory/>} />
            <Route path="/directory" element={<Directory/>} />
            <Route path="/self-checkin/:token" element={<SelfCheckin/>} />
            <Route path="/welcome/:token" element={<Welcome/>} />
            <Route path="/caccia-al-tesoro" element={<TreasureHunt/>} />
            <Route path="/caccia-al-tesoro/:huntId" element={<TreasureHunt/>} />
            <Route path="/muro-esploratori" element={<WallOfBadges/>} />
            <Route path="/wall-of-badges" element={<WallOfBadges/>} />
            <Route path="/citta/:city" element={<CityPage/>} />
            <Route path="/auth" element={<Auth/>} />
            <Route path="/p/:slug" element={<Vetrina/>} />
            <Route path="/dashboard" element={<Dashboard/>} />
            <Route path="/trade" element={<Trade/>} />
            <Route path="/forgot-password" element={<ForgotPassword/>} />
            <Route path="/reset-password" element={<ResetPassword/>} />
            <Route path="/pricing" element={<Pricing/>} />
            <Route path="/guest/auth" element={<GuestAuth/>} />
            <Route path="/guest/auth/callback" element={<GuestAuthCallback/>} />
            <Route path="/guest/auth/magic" element={<GuestMagicConsume/>} />
            <Route path="/guest/welcome" element={<GuestWelcome/>} />
            <Route path="/guest/dashboard" element={<GuestDashboard/>} />
            <Route path="/guest/dashboard/booking/:id" element={<GuestBookingDetail/>} />
            <Route path="/guest/:session_id" element={<GuestPortal/>} />
            <Route path="/guest/portal/:session_id" element={<GuestPortal/>} />
            <Route path="/payment/success" element={<PaymentSuccess/>} />
            <Route path="/payment/cancel" element={<PaymentCancel/>} />
          </Routes>
          <Toaster position="top-right"/>
        </BrowserRouter>
      </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;

// Listens for Service Worker "hh-navigate" messages (fired when the host
// clicks a Web Push notification) and performs SPA navigation via
// react-router. Mounted inside BrowserRouter so useNavigate is available.
function PushNavigationBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const onMessage = (event) => {
      const data = event.data || {};
      if (data.type !== "hh-navigate" || !data.url) return;
      try {
        // Only handle same-origin, in-app URLs
        const parsed = new URL(data.url, window.location.origin);
        if (parsed.origin !== window.location.origin) return;
        navigate(parsed.pathname + parsed.search + parsed.hash);
      } catch { /* ignore malformed URLs */ }
    };
    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, [navigate]);
  return null;
}
